<template>
  <div>
    <div class='layer-pop square-type'>
      <div class='view-content w880'>
        <button class='close' @click="$emit('close')">
          <span class='blind'>팝업 닫기</span>
        </button>
        <div class='scroll-area com-scroll-y'>
          <div class='com-tab'>
            <button :class='{ on: layerTab === 1 }' @click='layerTab = 1'>기간연장</button>
            <button :class='{ on: layerTab === 2 }' @click='onExtPeriod'>연장내역</button>
          </div>
          <!-- 기간연장 -->
          <div v-show='layerTab === 1' class='view-area'>
            <table class='com-table left'>
              <colgroup>
                <col style='width: 160px' />
                <col style='width: 600px' />
              </colgroup>
              <tbody>
              <tr>
                <th>회원명</th>
                <td>{{ customerName }}</td>
              </tr>
              <tr>
                <th>이용권명</th>
                <td>
                  <!-- <span class="ico type-1" v-if="prod.centerProduct.ticketType == 'P'">[개인]</span>
                  <span class="ico type-2" v-if="prod.centerProduct.ticketType == 'G'">[그룹]</span>
                  <span class="ico type-3" v-if="prod.centerProduct.ticketType == 'P'">[패키지]</span>
                  <span class="ico type-4" v-if="prod.centerProduct.ticketType == 'C'">[회원권]</span>
                  <span class="ico type-5" v-if="prod.centerProduct.ticketType == 'D'">[듀엣]</span>
                  <span class="ico type-6" v-if="prod.centerProduct.ticketType == 'O'">[OT]</span> -->
                  <!-- <span :class="{'ico': true, 'type-1': prod.centerProduct.ticketType === 'P', 'type-2': prod.centerProduct.ticketType === 'G',
                      'type-4': prod.centerProduct.ticketType === 'T', 'type-5': prod.centerProduct.ticketType === 'D', 'type-6': prod.centerProduct.ticketType === 'O' }">
                  {{ convertTicketTypeFormat(prod.centerProduct.ticketType) }} -->
                  <!-- </span> -->
                  {{ selectedExtendDetail.productName }}
                </td>
              </tr>
              <tr>
                <th>현재 유효기간</th>
                <td>{{ expireStartDate }}~{{ expireEndDate }}</td>
              </tr>
              <tr>
                <th>유형</th>
                <td>
                  <div class='line'>
                    <div class='com-radio'>
                      <input id='radio-pop-1' v-model='editField.expirePlusType' name='radio-pop'
                             type='radio'
                             value='N' />
                      <label for='radio-pop-1'>연기 (단순 기간연기)</label>
                    </div>
                  </div>
                  <div class='line'>
                    <div class='com-radio'>
                      <input id='radio-pop-2' v-model='editField.expirePlusType' name='radio-pop'
                             type='radio'
                             value='H' />
                      <label for='radio-pop-2'>홀딩 (연장 기간동안 예약 및 입장 불가)</label>
                    </div>
                  </div>
                  <span class='red'>  <span class='imp'>*</span> 홀딩 기간 중 예약은 자동 취소 됩니다. </span>
                </td>
              </tr>
              <tr>
                <th>연장기간 <span class='imp'>*</span></th>
                <td>
                  <div class='line'>
                    <single-calendar
                        ref='expirePlusStartDt'
                        :disabled-date-list='disabledDateList'
                        :start-date='editField.expirePlusStartDt'
                        @update='updateExpStartDt'></single-calendar>
                    ~
                    <single-calendar
                        ref='expirePlusEndDt'
                        :disabled-date-list='disabledDateList'
                        :end-date='editField.expirePlusEndDt'
                        @update='updateExpEndDt'></single-calendar>
                  </div>
                  <div class='line'>
                    <input v-model='editField.expirePlusDay' class='center w60'
                           type='text'
                           @keypress='isNumber($event)'
                           @keyup='onInputExpPlusDay' /><span class='txt'>일</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>변경 후 유효기간</th>
                <td>
                  <span class='red'>{{ expireStartDate }} ~ {{ calExpEndDt }}</span>
                </td>
              </tr>
              <tr>
                <th>등록자 <span class='imp'>*</span></th>
                <td>
                  <select-form :select-data='expPlusStaffList' :select-value='expPlusStaffValueList'
                               :selected-value='editField.expirePlusStaffId'
                               class='w200'
                               @update:set='(val) =>(editField.expirePlusStaffId = val)'
                  />
                </td>
              </tr>
              <tr>
                <th>연기 사유 <br/>({{ editField.expirePlusMemo.length | numberFormatFilter }} / {{MEMO_MAX_LEN | numberFormatFilter}})</th>
                <td>
                  <textarea v-model='editField.expirePlusMemo' class='full' :maxlength="MEMO_MAX_LEN"></textarea>
                </td>
              </tr>
              </tbody>
            </table>
            <div class='bottom-btn'>
              <button class='com-btn' @click="$emit('close')">
                취소
              </button>
              <button v-if='!buttonDisabled' class='com-btn blue' @click='onPostExtPeriod'>
                등록
              </button>
            </div>
          </div>
          <!-- //기간연장 -->
          <!-- 연장내역 -->
          <div v-show='layerTab == 2' class='view-area'>
            <div class='user-info-box'>
              <div class='line'>
                <span class='name'>{{ customerName }}</span>
                <span class='first right'>최초 유효기간 |{{ selectedExtendDetail.orgExpireStartDt }}
                                    ~{{ selectedExtendDetail.orgExpireEndDt }}</span>
              </div>
              <div class='line'>
                                <span class='name'>
                                    <span :class="{ico: true,'type-1':ticketType === 'P',
                                                'type-2':ticketType === 'G',
                                            'type-4':ticketType === 'T',
                                            'type-5':ticketType === 'D',
                                            'type-6':ticketType === 'O',
                                            'type-8':ticketType === 'S',}">
                                        {{ convertTicketTypeFormat(ticketType) }}
                                    </span>
                                    {{ selectedExtendDetail.productName }}
                                </span>
                <span class='now right'>현재 유효기간 | {{ expireStartDate }} ~ {{ expireEndDate }}</span>
              </div>
              <div class='line'>
                                <span class='cnt right'>총 연장횟수 :
                                    {{ extPeriodList.length }}회</span>
              </div>
            </div>
            <table class='com-table'>
              <colgroup>
                <col style='width: 90px' />
                <col style='width: 150px' />
                <col style='width: 150px' />
                <col style='width: 150px' />
                <col style='width: 150px' />
                <col style='width: 80px' />
                <col style='width: 80px' />
              </colgroup>
              <thead>
              <tr>
                <th>등록일</th>
                <th>연장기간</th>
                <th>변경 전 기간</th>
                <th>변경 후 기간</th>
                <th>연기사유</th>
                <th>유형</th>
                <th>관리</th>
              </tr>
              </thead>
              <tbody>
              <!-- <tr>
                  <td>2020.01.20<br>13:00:32</td>
                  <td>
                      2020.01.20 ~<br>2020.01.30
                      <div class="line">
                          <span class="red">(10일)</span>
                      </div>
                  </td>
                  <td>2020.01.10 ~<br>2020.01.20</td>
                  <td>2020.01.10 ~<br>2020.01.20</td>
                  <td>겨울휴가</td>
                  <td>홀딩</td>
                  <td>
                      <div class="line">
                          <button class="com-btn red">삭제</button>
                      </div>
                      <div class="line">
                          <button class="com-btn">수정</button>
                      </div>
                  </td>
              </tr> -->
              <tr v-for='(e, index) in extPeriodList' :key='index'>
                <!-- 등록일 -->
                <td>{{ e.c_upd_dt | timestampFilter2 }}</td>
                <!-- 연장기간 -->
                <td>{{ e.c_exp_plus_start_dt | timestampFilter }}
                  ~<br />{{ e.c_exp_plus_end_dt| timestampFilter }}
                  <div class='line'>
                    <span class='red'>({{ e.c_exp_plus_day }}일)</span>
                  </div>
                </td>
                <!-- 변경 전 기간 -->
                <td>
                  {{ e.c_org_exp_start_dt | timestampFilter }}
                  ~<br />{{ e.c_org_exp_end_dt | timestampFilter }}
                </td>
                <!-- 변경 후 기간 -->
                <td>
                  {{ e.c_exp_start_dt | timestampFilter }}
                  ~<br />{{ e.c_exp_end_dt | timestampFilter }}
                </td>
                <!-- 연기사유 -->
                <td>{{ e.c_exp_plus_memo }}</td>
                <!-- 유형 -->
                <td>
                  {{ convertPlusType(e.c_exp_plus_type_cd) }}
                </td>
                <!-- 관리 -->
                <td>
                  <div v-if='index === 0' class='line'>
                    <button class='com-btn' @click="checkAllowedClick('LE', 4, () => onEditExtPeriod(e))">
                      수정
                    </button>
                  </div>
                  <div v-if='index === 0' class='line'>
                    <button class='com-btn red' @click="checkAllowedClick('LE', 4, onDeleteExtPeriod)">
                      삭제
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if='extPeriodList.length === 0'>
                <td colspan='100'>
                  등록된 내용이 없습니다.
                </td>
              </tr>
              </tbody>
            </table>
            <div class='bottom-btn'>
              <button class='com-btn' @click="$emit('close')">
                취소
              </button>
              <!-- <button class="com-btn blue">등록</button> -->
            </div>
          </div>
          <!-- //연장내역 -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/assets/js/api';
import moment from 'moment';
import {MixinAllowedMenu} from '@/assets/js/mixinAllowedMenu';
import {Utils} from '@/assets/js/utils';
import {pagingInfo} from '@/assets/js/common';
import PeriodEdit from '@/components/PeriodEdit.vue';

export default {
  name: 'PeriodPop',
  mixins: [MixinAllowedMenu],
  props: {
    customerName: '', // 이용권을 이용하는 회원의 이름
    selectedExtendDetail: '', // 팝업에 보여질 선택한 연장기간 상세
    layerTabNumber: '', // 기간연장 팝업 탭 활성화
    expPlusStaffList: '', // 상담자 이름 목록
    expPlusStaffValueList: '', // 상담자 값(id) 목록
    centerId: '', // 센터 아이디,
    centerContractId: '',
    centerStaffId: '', // 센터 스태프 아이디
  },
  computed: {
    // 유효기간 계산
    expireStartDate() {
      const {expireStartDt, orgExpireStartDt} = this.selectedExtendDetail;
      return !Utils.isEmpty(expireStartDt) ? expireStartDt : orgExpireStartDt;
    },
    expireEndDate() {
      const {expireEndDt, orgExpireEndDt} = this.selectedExtendDetail;
      return !Utils.isEmpty(expireEndDt) ? expireEndDt : orgExpireEndDt;
    },
    ticketType() {
      if (!Utils.isEmpty(this.selectedExtendDetail.centerProduct)
          && !Utils.isEmpty(this.selectedExtendDetail.centerProduct.ticketType)) {
        return this.selectedExtendDetail.centerProduct.ticketType;
      }
      return '';
    },
    calExpEndDt() {
      // 변경 후 유효기간 종료일 계산
      return moment(this.expireEndDate).add(this.editField.expirePlusDay, 'days').format('YYYY-MM-DD');
    },
  },
  data() {
    return {
      selectedContract: null,
      productIndex: 0,
      layerTab: 1,
      editField: {
        expirePlusType: '',
        expirePlusStartDt: '',
        expirePlusEndDt: '',
        expirePlusDay: '',
        expirePlusStaffId: '',
        expirePlusMemo: '',
      },
      periodPop: true,
      extPeriodList: [], // 연장 히스토리 내역
      disabledDateList: [], // 연장되는 기간들의 목록
      pagingInfo: {...pagingInfo},
      buttonDisabled: false,
      buttonExecuted : false,
    };
  },
  watch: {},
  created() {
    this.MEMO_MAX_LEN = 1000;
  },
  mounted() {
    this.initExtentionEditField();
  },
  updated() {
  },
  methods: {
    async initExtentionEditField() {
      const now = moment().format('YYYY-MM-DD');
      this.layerTab = this.layerTabNumber;
      if (this.layerTab === 2) {
        this.onExtPeriod();
      }

      const {data} = await this.getExtPeriod();
      this.extPeriodList = data.items;

      for (const e of this.extPeriodList) {
        this.disabledDateList.push({
          startDate: e.c_exp_plus_start_dt,
          endDate: e.c_exp_plus_end_dt,
        });
      }

      let expirePlusStartDt = now;
      let expirePlusEndDt = expirePlusStartDt;

      if (moment(expirePlusStartDt).isBefore(this.expireStartDate)) {
        expirePlusStartDt = this.expireStartDate;
        expirePlusEndDt = this.expireStartDate;
      } else if (moment(expirePlusStartDt).isAfter(this.expireEndDate)) {
        expirePlusStartDt = this.expireEndDate;
      }

      this.editField = {
        expirePlusType: 'N',
        expirePlusStartDt,
        expirePlusEndDt,
        expirePlusDay: 1,
        expirePlusStaffId: parseInt(this.centerStaffId),
        expirePlusMemo: '',
      };
    },

    // 기간연장 관련(조회)
    async onExtPeriod() {
      try {
        const {data} = await this.getExtPeriod();
        this.extPeriodList = data.items;

        for (const e of this.extPeriodList) {
          this.disabledDateList.push({
            startDate: e.c_exp_plus_start_dt,
            endDate: e.c_exp_plus_end_dt,
          });
        }

        this.periodPop = true;
        this.layerTab = 2;

        this.selectedExtendDetail.expireEndDt = moment(this.extPeriodList[0].c_exp_end_dt).format('YYYY-MM-DD')

        // this.initExtentionEditField();
      } catch (error) {
        console.log(error);
      }
    },

    // 스웨거 검색: 센터회원 기간연장내역 페이징 목록 조회
    getExtPeriod() {
      const {centerCustomerId, centerContractId} = this;
      const searchParams = {
        startDate: moment().subtract(1, 'years').format('YYYYMMDD'),
        endDate: moment().format('YYYYMMDD'),
        centerCustomerId,
        centerContractId,
      };
      return api.get(
          `/admin/api/center/${this.centerId}/contract/extend`,
          {
            params: {
              page: 1,
              limit: 10000,
              startDate: moment().subtract(1, 'years').format('YYYYMMDD'),
              endDate: moment().add(10, 'years').format('YYYYMMDD'),
              centerCustomerId,
              centerContractId,
            },
          },
      );
    },

    // 유효기간 연장 기간 시작일 변경시
    updateExpStartDt(date) {
      // 현재 유효기간 이내 여부 체크
      if (moment(date).isBefore(this.expireStartDate)) {
        alert('현재 유효기간 내에서 선택하세요.');
        this.editField.expirePlusStartDt = this.expirePlusStartDt;
      }
          /*
    else if(moment(date).isAfter(this.expireEndDate)) {
        alert("현재 유효기간 내에서 선택하세요.");
        this.editField.expirePlusStartDt = this.expireEndDate;
    }
     */
      // 연장 종료날짜보다 큰 경우
      else if (!Utils.isEmpty(this.editField.expirePlusEndDt) && moment(date).isAfter(this.editField.expirePlusEndDt)) {
        console.log('date', date);
        console.log('this.editField.expirePlusEndDt', this.editField.expirePlusEndDt);

        // alert("종료날짜보다 이후날짜를 선택할 수 없습니다...");
        // this.$refs.expirePlusStartDt.inputValue = this.editField.expirePlusEndDt;
        // this.$refs.expirePlusStartDt.setCalendarSelectedDate(this.editField.expirePlusEndDt);
        // this.editField.expirePlusStartDt = this.editField.expirePlusEndDt;

        this.editField.expirePlusStartDt = date;
        this.editField.expirePlusEndDt = date;

        this.$refs.expirePlusEndDt.inputValue = date;
        this.$refs.expirePlusEndDt.setCalendarSelectedDate(this.editField.expirePlusEndDt);
        this.editField.expirePlusEndDt = this.editField.expirePlusEndDt;
      } else {
        this.editField.expirePlusStartDt = date;
      }

      this.checkDuplicateExpireDate();
      this.calculateExpirePlusDay();
    },

    // 유효기간 연장 기간 종료일 변경시
    updateExpEndDt(date) {
      // 현재 유효기간 이내 여부 체크
      if (moment(date).isBefore(this.expireStartDate)) {
        alert('현재 유효기간 내에서 선택하세요.');
        // this.$refs.expirePlusEndDt.inputValue = this.editField.expirePlusStartDt;
        this.editField.expirePlusEndDt = this.expirePlusStartDt;
      }
          /*
    else if(moment(date).isAfter(this.expireEndDate)) {
        alert("현재 유효기간 내에서 선택하세요.");
        this.editField.expirePlusEndDt = this.expireEndDate;
    }
     */
      // 연장 시작날짜보다 작은 경우
      else if (!Utils.isEmpty(this.editField.expirePlusStartDt) &&
          moment(date).isBefore(this.editField.expirePlusStartDt)) {
        // alert("시작날짜보다 이전날짜를 선택할 수 없습니다.");
        // this.$refs.expirePlusEndtDt.setCalendarSelectedDate(this.editField.expirePlusStartDt);
        // this.editField.expirePlusEndDt = this.editField.expirePlusStartDt;

        this.editField.expirePlusStartDt = date;
        this.editField.expirePlusEndDt = date;

        this.$refs.expirePlusStartDt.inputValue = date;
        this.$refs.expirePlusStartDt.setCalendarSelectedDate(this.editField.expirePlusStartDt);
        this.editField.expirePlusStartDt = this.editField.expirePlusStartDt;
      } else {
        this.editField.expirePlusEndDt = date;
      }

      this.checkDuplicateExpireDate();
      this.calculateExpirePlusDay();
    },

    checkDuplicateExpireDate() {
      this.buttonDisabled = false;
      if (!Utils.isEmpty(this.editField.expirePlusEndDt)) {
        const {expirePlusStartDt, expirePlusEndDt} = this.editField;
        for (const disabledDate of this.disabledDateList) {
          const {startDate, endDate} = disabledDate;
          // console.log("expirePlusStartDt", expirePlusStartDt);
          // console.log("startDate", startDate);
          // console.log("expirePlusEndDt", expirePlusEndDt);
          // console.log("endDate", endDate);
          if (moment(expirePlusStartDt).isBefore(startDate) && moment(expirePlusEndDt).isAfter(endDate)) {
            alert('연장 기간을 중복해서 신청할 수 없습니다.');
            this.buttonDisabled = true;
            break;
          }
        }
      }
    },

    // 연장 일수 입력시
    onInputExpPlusDay() {
      if (Utils.isEmpty(this.editField.expirePlusDay)) {
        return false;
      }

      if (this.editField.expirePlusDay < 1) {
        this.editField.expirePlusDay = 1;
      }

      const dFormat = 'YYYY-MM-DD';
      this.editField.expirePlusEndDt = moment(this.editField.expirePlusStartDt, dFormat).
          add(this.editField.expirePlusDay - 1, 'days').
          format(dFormat);
    },

    // 기간 연장 등록 버튼 클릭시
    async onPostExtPeriod() {
     
      if(this.buttonExecuted) return;
      if(!this.buttonExecuted){
        this.buttonExecuted = true;
      }
      if (!confirm('연장하시겠습니까?')) {
        this.buttonExecuted = false;
        return false;
      }

      try {
        await this.getPostExtPeriod();

        this.periodPop = false;
        this.editField = {
          // 기간연장 등록 변수 초기화
          expirePlusType: '-',
          expirePlusStartDt: this.today,
          expirePlusEndDt: null,
          expirePlusDay: '',
          expirePlusStaffId: parseInt(this.staffId),
          expirePlusMemo: '',
        };

        alert('기간 연장이 적용되었습니다.');
        this.$emit('period-init');

      } catch (error) {
        console.log(error);
        this.buttonExecuted = false;

      }
    },

    getPostExtPeriod() {
      // 스웨거검색: 센터회원 기간연장내역 저장/수정
      const params = this.getModifyParams(); // 가공된 파라미터
      return api.put(`/admin/api/center/${this.centerId}/contract/extend/${this.centerContractId}`, params);
    },

    // 기간연장 수정 파라미터 가공
    getModifyParams() {
      const {
        expirePlusType,
        expirePlusStartDt,
        expirePlusEndDt,
        expirePlusDay,
        expirePlusStaffId,
        expirePlusMemo,
      } = this.editField;

      const params = {
        expirePlusType,
        expirePlusStartDt,
        expirePlusEndDt,
        expirePlusDay,
        expirePlusStaffId,
        expirePlusMemo,
      };

      return params;
    },

    // 이용권 코드 변환
    convertTicketTypeFormat(type) {
      if (type === 'P') {
        return '[개인]';
      } else if (type === 'O') {
        return '[OT]';
      } else if (type === 'D') {
        return '[듀엣]';
      } else if (type === 'G') {
        return '[그룹]';
      } else if (type === 'C') {
        return '[쿠폰]';
      } else if (type === 'T') {
        return '[회원권]';
      } else if (type === 'S') {
        return '[운동복]';
      }
    },

    calculateExpirePlusDay() {
      // 연장시작일자/연장종료일자로 연장일수 계산
      const {expirePlusStartDt, expirePlusEndDt} = this.editField;
      if (Utils.isEmpty(expirePlusStartDt) || Utils.isEmpty(expirePlusEndDt)) {
        return false;
      }

      const dFormat = 'YYYY-MM-DD';
      const diffDays = moment(expirePlusEndDt, dFormat).diff(moment(expirePlusStartDt, dFormat), 'days');

      this.editField.expirePlusDay = diffDays + 1;

      /*
let endDt = moment(this.editField.expirePlusEndDt, 'YYYY-MM-DD'); // 변경한 연장기간 종료일
let startDt = moment(this.selectedExtendDetail.c_exp_end_dt).startOf('day'); // 현재 유효기간 종료일
let diffDays = moment
.duration(curExpEndDt.diff(curExpStartDt))
.asDays(); // 현재 유효기간 종료일 ~ 연장하는 유효기간 종료일 차이를 구함
this.editField.expirePlusEndDt = val;
this.editField.expirePlusDay = diffDays;
*/
    },

    convertPlusType(type) {
      if (type === 'N') {
        return '연장';
      } else if (type === 'H') {
        return '홀딩';
      }
    },

    // 수정버튼 클릭시
    onEditExtPeriod(expHistory) {
      //this.$emit('close')

      this.$modal.show(
          PeriodEdit,
          {
            expPlusStaffList: this.expPlusStaffList,
            expPlusStaffValueList: this.expPlusStaffValueList,
            ticketExpHistory: expHistory
          },
          {
            width: 880,
            height: 700,
          },
          {
            'closed': this.onExtPeriod
          }
      )
    },

    // 기간 연장 삭제 버튼 클릭시
    async onDeleteExtPeriod() {
      if (!confirm('기간 연장을 삭제하시겠습니까?')) {
        return false;
      }

      try {
        await this.getDeleteExtPeriod();

        alert('기간 연장을 삭제하였습니다.');

        this.$emit('period-init');
      } catch (error) {
        Utils.alertResponseErrorMessge(error);
        console.log(error);
      }
    },

    // 기간 연장 삭제 API
    getDeleteExtPeriod() {
      return api.delete(
          `/admin/api/center/${this.centerId}/contract/extend/${this.centerContractId}/${this.extPeriodList[0].c_center_tick_exp_history_id}`);
    },
  },

};
</script>
